import { motion } from "framer-motion";
import { INSIGHTS } from "@/lib/content";

const fade = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  viewport: { once: true, margin: "-80px" },
};

export default function Insights() {
  return (
    <section id="insights" data-testid="insights-section" className="border-t border-hairline">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-28 lg:py-40">
        <motion.div {...fade} className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 max-w-5xl">
          <div>
            <span className="overline" data-testid="insights-overline">Philosophy & Insights</span>
            <h2 className="font-serif text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight mt-6">
              Notes from the chair.
            </h2>
          </div>
          <p className="font-sans text-sand text-base md:text-lg leading-relaxed max-w-md">
            Short essays on the operator behind the trade. Published when there is
            something worth publishing — not on a schedule.
          </p>
        </motion.div>

        <div className="mt-20 divide-y divide-hairline border-t border-b border-hairline">
          {INSIGHTS.map((p, i) => (
            <motion.article
              key={p.kicker}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`insight-${i}`}
              className="group py-10 grid grid-cols-12 gap-6 items-start hover:bg-elevated/40 transition-colors"
            >
              <div className="col-span-12 md:col-span-2 overline pt-2">{p.kicker}</div>
              <div className="col-span-12 md:col-span-7">
                <h3 className="font-serif text-2xl md:text-3xl text-bone group-hover:text-platinum transition-colors">
                  {p.title}
                </h3>
                <p className="mt-4 font-sans text-sand leading-relaxed max-w-2xl">{p.body}</p>
              </div>
              <div className="hidden md:flex md:col-span-3 justify-end pt-3">
                <span className="text-xs tracking-[0.25em] uppercase text-smoke group-hover:text-platinum transition-colors">
                  Read →
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
